import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'yetki';

var yetkiService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,

    yetkiListesi() {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            methodName: 'yetkiListesi',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },

    yetkiTanimla(managerId, authorities) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            methodName: 'yetkiTanimla',
            'data[yoneticiID]': managerId,
            serviceName: moduleName,
        };

        if (typeof authorities.forEach === 'function') {
            authorities.forEach((item, index) => {
                param[`data[yetkiID][${index}]`] = item;
            });
        }

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },

    yoneticiYetkiListesi(id) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            methodName: 'yoneticiYetkiListesi',
            'data[yoneticiID]': id,
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};
export default yetkiService;
